export const GET_STARTED_STEPS = [
  {
    title: 'Create your free account',
    body: 'Sign up in seconds, no credit card required to get started.',
  },
  {
    title: 'Build your page',
    body: 'Add links, images, text, and social icons with the drag-and-drop editor.',
  },
  {
    title: 'Share your unique link',
    body: 'Add your new link to your bio and start tracking every click.',
  },
];

export function getExamples(feature1: string, feature2: string) {
  return {
    starting: [
      'A bio page with your top 2-3 links',
      feature1,
      'Social icons linking to every platform you use',
    ],
    established: [
      feature1,
      feature2,
      'A custom domain with UTM-tracked campaign links',
    ],
  };
}

export function getFreeFaqAnswer(
  siteName: string,
  isLaunchActive: boolean,
): string {
  if (isLaunchActive) {
    return `${siteName} is currently offering full access free to its first 500 signups as a launch promotion. After that, standard plans apply, but every account can start with a free bio page and short links.`;
  }
  return `${siteName}'s launch promotion has ended, but every account can still start with a free bio page and short links, with paid plans available for advanced features like custom domains, UTM tracking, and retargeting pixels.`;
}

export function getCommonMistakes(name: string) {
  return [
    {
      title: 'Using one static link for everything',
      body: `Most ${name} lose clicks by sending every platform to the exact same generic link instead of a page built around specific goals.`,
    },
    {
      title: 'Never checking click analytics',
      body: `Without per-link data, it's just a guess which offer or platform is actually working.`,
    },
    {
      title: 'Letting expired offers stay live',
      body: `A stale promo or sold-out link hurts trust. Set links to expire automatically instead of forgetting about them.`,
    },
    {
      title: 'Sticking with a generic, unbranded link',
      body: `A shared, generic bio-link domain looks less trustworthy than a page on your own custom domain.`,
    },
  ];
}
